import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export interface TasteProfile {
  body: number;
  tannin: number;
  acidity: number;
  oak: number;
  sweetness: number;
}

export interface TasteSnapshot {
  tasteProfile: TasteProfile;
  totalTasted: number;
  topGrapes: string[];
  topRegions: string[];
  snapshotDate: string;
}

export function useTasteProfile() {
  const { data, isLoading: loading } = useQuery({
    queryKey: ['taste-profile'],
    queryFn: async () => {
      const { data: snapshots } = await apiClient.models.TasteSnapshot.list({
        limit: 12,
      });
      if (!snapshots || snapshots.length === 0) return { snapshot: null, history: [] };

      const sorted = [...snapshots].sort(
        (a, b) => new Date(b.snapshotDate).getTime() - new Date(a.snapshotDate).getTime()
      );

      const latest = sorted[0];
      return {
        snapshot: {
          tasteProfile: latest.tasteProfile as TasteProfile,
          totalTasted: latest.totalTasted ?? 0,
          topGrapes: (latest.topGrapes as string[]) ?? [],
          topRegions: (latest.topRegions as string[]) ?? [],
          snapshotDate: latest.snapshotDate,
        } satisfies TasteSnapshot,
        history: sorted.map((s) => ({
          date: s.snapshotDate,
          profile: s.tasteProfile as TasteProfile,
          totalTasted: s.totalTasted ?? 0,
        })),
      };
    },
  });

  return {
    snapshot: data?.snapshot ?? null,
    history: data?.history ?? [],
    loading,
  };
}
